import styled from 'styled-components'

export const BackgroundImage = styled.img`
  width: auto;
  height: auto;
  max-width: 80vw;
  max-height: 100%;
  object-fit: contain;
`
